import * as React from 'react';
import { groupBy } from 'lodash';
import * as fetch from 'isomorphic-fetch';

// eslint-disable-next-line max-len
const JOBS_URL = 'https://api.smartrecruiters.com/v1/companies/Etsy2/postings?custom_field.5dfa5643852dfd7a67ca1713=92fcffd1-2a5e-4ab5-9704-6792731b7b3b';
const LISTING_URL = 'https://jobs.smartrecruiters.com/Etsy2';

interface IJob {
  id: string;
  name: string;
  location: {
    city: string;
    region: string;
    country: string;
    remote: boolean;
  };
  function: {
    label: string;
  };
}

interface IResp {
  content: IJob[];
}

export function useJobs() {
  const [jobs, setJobs] = React.useState<IJob[]>([]);

  React.useEffect(() => {
    async function fetchResp() {
      try {
        const resp = await fetch(JOBS_URL);
        const body: IResp = await resp.json();
        setJobs(body.content);
      } catch (e) {
        throw new Error(`could not fetch job - ${e}`);
      }
    }

    fetchResp();
  }, []);

  return jobs;
}

function Location(props: { location: IJob['location'] }) {
  const { city, region, country, remote } = props.location;
  let desc;
  if (remote) {
    desc = 'Remote';
  } else {
    desc = `${city}, ${region}`;
    if (country.toUpperCase() !== 'US') {
      desc = `${desc}, ${country}`;
    }
  }

  return (
    <div className="srjobs__location">
      {desc}
    </div>
  );
}

export function Department(props: { jobs: IJob[] }) {
  return (
    <ul>
      {props.jobs.map((job) => (
        <li key={job.id}>
          <a
            href={`${LISTING_URL}/${job.id}`}
            className="srjobs__job d-flex fx-justify-between fx-dir-row"
            rel="noopener noreferrer"
            target="_blank"
          >
            <div className="srjobs__name">{job.name}</div>
            <Location location={job.location} />
          </a>
        </li>
      ))}
    </ul>
  );
}

function DepartmentHeader(props: { dept: string}) {
  const dept = props.dept.toLocaleLowerCase() === 'engineering' ? 'Product & Engineering' : props.dept;
  return (
    <h3 className="srjobs__department">{dept}</h3>
  );

}

export default function SmartRecruiterJobs() {
  const jobs = useJobs();
  if (jobs.length === 0) { return null; }
  const grouped = groupBy(jobs, 'function.label');

  return (
    <div className="srjobs">
      {Object.keys(grouped).map((dept) => (
        <React.Fragment key={dept}>
          <DepartmentHeader dept={dept} />
          <Department jobs={grouped[dept]} />
        </React.Fragment>
      ))}
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/embeds/smart_recruiter_jobs.tsx